import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';
import { put, fork, take, select } from 'redux-saga/effects';
import * as actions from './actions';


function* init() {
  while (true) {
    const { localId } = yield take(actions.INIT.BEGIN);
    const { categoryOptions } = yield select(state => state.configuration.project.editor.category);
    const value = cloneDeep(find(categoryOptions, x => x.$$localId === localId) || { invalid: true, value: {} });
    value.dependencyOptions = categoryOptions.filter(x => x.value.id !== value.value.id && x.value.id > 0 ).map((x) => { return {id: x.value.id, title: x.value.name}});
      yield put(actions.init.end({ selectedCategory: value }));
  }
}

function* resetChanges() {
  while (true) {
    yield take(actions.RESET_CHANGES.BEGIN);
    const {
      categories,
      currentCategory: selectedCategory,
       } = yield select(state => state.configuration.project.editor.category);
    const categoryValue = find(categories, x => x.id === selectedCategory.value.id);
    const value = cloneDeep(categoryValue);
    yield put(actions.resetChanges.end({ value }));
  }
}

function* checkValidation() {
  while(true) {
    yield take(actions.CHECK_VALIDATION.BEGIN);
    const { categories, currentCategory } = yield select(state => state.configuration.project.editor.category);
    let errors;
    for(const category of categories) {
      if(category.name === currentCategory.value.name && category.id !== currentCategory.value.id) {
        errors = {name: true};
        break;
      }
    }
    yield put(actions.checkValidation.end({ errors }));
  }
}

export default function* currentCategory() {
  yield fork(init);
  yield fork(resetChanges);
  yield fork(checkValidation)
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/category/currentCategory/saga.js